import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import * as Glob from '../../Globale';
import * as Dati from '../../Dati';
import { Trad} from '../Trad';
import { PortletToogleIcon } from '../common/PortletToogleIcon';
import ChiamaWeb, {CChiamaWebParametri} from '../../ChiamaWeb';

export const DashboardAzioniVeloci: React.FC<{}> = () => {
    const [canCreateBond, setCanCreateBond] = useState(false);
    const [canCreateNeutral, setCanCreateNeutral] = useState(false);
    const [canCreateCAR, setCanCreateCAR] = useState(false);
    
    useEffect(() => {
        const Param: CChiamaWebParametri = {
            URL: "/api/binder/RamiDisponibili?id_AnagA=" + Glob.GetSessione().ID_Anag,
            OnRis: (sender: ChiamaWeb, dati: Dati.CRisAPILista<number>) => {
                for (let I = 0; I < dati.Dati.length; I++) {
                    switch (dati.Dati[I]) {
                        case Glob.TipiRami_Fideiussioni:
                            setCanCreateBond(true);
                            break;
                        case Glob.TipiRami_CAR:
                            setCanCreateCAR(true);
                            break;
                        case Glob.TipiRami_Infortuni:
                            setCanCreateNeutral(true);
                            break;
                        case Glob.TipiRami_Enti:
                            setCanCreateNeutral(true);
                            break;
                        case Glob.TipiRami_Property:
                            setCanCreateNeutral(true);
                            break;
                    }
                }
                let Sessione = Glob.GetSessione();
                if (Sessione.Gruppi.includes("26"))
                {
                    setCanCreateCAR(true);
                }
                if (Sessione.Gruppi.indexOf("25") > 0)
                {
                    setCanCreateNeutral(true);
                }
            }
        }
        new ChiamaWeb().Chiama(Param);
    }, []);

    return canCreateBond || canCreateNeutral || canCreateCAR ? (
        <div className="kt-portlet portlet-shadow kt-portlet--sortable" data-ktportlet="true" >
            <div className="kt-portlet__head ui-sortable-handle">
                <div className="kt-portlet__head-label">
                    <h3 className="kt-portlet__head-label">{Trad.Trad("Azioni veloci")}</h3>
                </div>
                <div className="kt-portlet__head-toolbar">
                    <PortletToogleIcon />
                </div>
            </div>
            {canCreateBond && (
                <div className="kt-portlet__body">
                    <div className="kt-widget4">
                        <NavLink to="/fidenuovo" className="text-right kt-padding-r-0 kt-widget4__icon">
                            {Trad.Trad("Nuovi affidamenti/Nuove fideiussioni")}
                        </NavLink>
                    </div>
                </div>
            )}
            {canCreateNeutral && (
                <div className="kt-portlet__body">
                    <div className="kt-widget4">
                        <NavLink to="/createneutral" className="text-right kt-padding-r-0 kt-widget4__icon">
                            {Trad.Trad("Nuova polizza neutra")}
                        </NavLink>
                    </div>
                </div>
            )}
            {canCreateCAR && (
                <div className="kt-portlet__body">
                    <div className="kt-widget4">
                        <NavLink to="/createpolicycar" className="text-right kt-padding-r-0 kt-widget4__icon">
                            {Trad.Trad("Nuova polizza CAR")}
                        </NavLink>
                    </div>
                </div>
            )}
        </div>
    ) : null;
}




// WEBPACK FOOTER //
// ./src/components/Dashboards/DashboardAzioniVeloci.tsx